import { useEffect } from "react";
import PageHeader from "@/components/PageHeader";
import { useSeo } from "@/lib/seo";

export default function LegalPage({ eyebrow, title, italicWord, sections, docTitle, docDesc, path }) {
  useSeo({ title: docTitle, description: docDesc, path });
  useEffect(() => {}, []);

  return (
    <div data-testid="legal-page">
      <PageHeader eyebrow={eyebrow} title={title} italicWord={italicWord} description={`Last updated ${new Date().toLocaleDateString("en-IN", { month: "long", year: "numeric" })}.`} />
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="space-y-14">
            {sections.map((s, i) => (
              <div key={i}>
                <div className="text-xs uppercase tracking-[0.22em] text-blue-600 font-semibold">/{String(i + 1).padStart(2, "0")}</div>
                <h2 className="mt-3 font-display text-2xl md:text-3xl font-medium tracking-tight text-slate-900">{s.h}</h2>
                <div className="mt-4 space-y-4 text-slate-600 text-base md:text-lg leading-relaxed">
                  {s.p.map((para, j) => <p key={j}>{para}</p>)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
